import React from "react";
import { useState, useEffect } from "react";
import moment from "moment";
import { numDifferentiation, titleCase } from "../../common/app_constant";
import {
  ENV,
  PJ_URL,
  s3_bucket_prod_url,
  s3_bucket_uat_url,
  SUB_DIRECTORY,
} from "../../common/constant";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useRef } from "react";
import _ from "lodash";
import DocumentCard from "../document_card";
import EndorsementCard from "../endorsement_card";
import RcUpload_Document from "../rc_document_upload";
import features from "../../routes/app/auth/policies/feature.json";
import { actionSourceForEnquiry, resetGetSource } from "../../routes/app/auth/policies/store";


const PolicyCard = (props) => {
  const [clicked, setClicked] = useState("0");
  const [appliedFeatures, setAppliedFeatures] = useState([]);
  const dispatch = useDispatch();
  const contentEl = useRef();
  const [isUploadDoc, setIsUploadDoc] = useState(false);
  const [policyId, setPolicyId] = useState(null);
  const [featuresDescriptionMap, setFeaturesDescriptionMap] = useState(null);
  const navigation = useNavigate();
  const { getSource } = useSelector(state => ({
    ...state.policyStore,
  }));


  const handleToggle = (index) => {
    if (clicked === index) {
      return setClicked("0");
    }
    setClicked(index);
  };

  useEffect(() => {
    const availableFeatures = props?.detail?.plan?.planFeatures;
    const appliedFeatures = availableFeatures
      ? availableFeatures.map((feature) => feature.name.trim().toLowerCase())
      : [];
    setAppliedFeatures(appliedFeatures);
    setFeaturesDescriptionMap(props?.featuresDescriptionMap);
  }, [props]);

  const renderDocuments = (item) => {
    var arrDoc = [];

    item != null && item?.length > 0
      ? item.map((item, index) => {
        arrDoc.push(
          <div className="col-md-6 mb-2" key={index}>
            <DocumentCard
              policyData={props?.detail}
              detailDocument={item}
              documentId={index}
              actionDownload={props.actionDownload}
            />
          </div>
        );
      })
      : arrDoc.push(
        <div class="col-md-12">
          <div class="card">
            <div class="card-body">No Documents Uploaded</div>
          </div>
        </div>
      );

    return arrDoc;
  };

  const renderEndorsement = (item) => {
    var arrEndorsement = [];

    item != null && item?.length > 0
      ? item.map((item, index) => {
        arrEndorsement.push(
          <div class="col-md-12">
            <EndorsementCard
              detailEndorsement={item}
              endorsementIndex={index}
            />
          </div>
        );
      })
      : arrEndorsement.push(<></>);

    return arrEndorsement;
  };
  useEffect(() => {
    if (getSource) {
      dispatch(resetGetSource());
      if (getSource.status === true) {
        // alert(getSource.data?.source)
        const token = localStorage.getItem("token");
        const policyIdFromCard = policyId
        if (policyIdFromCard) {
          const url = `${PJ_URL}?token=${token}&source=${getSource.data?.source}&quote_id=${getSource.data?.quoteId}`;
          setPolicyId(null)
          console.log(url)
          // alert(policyId)
          window.open(url);
          // window.location.href = url;
        }

        // window.location.href = url;
      }
    }
  }, [getSource, policyId])


  // const isRenewedPolicy = (item, allPolicies) => {
  //   return allPolicies?.some(p =>
  //     p.vehicle_no === item.vehicle_no && p.id !== item.id &&
  //     new Date(p.policy_start_date) > new Date(item.policy_expiry_date)
  //   );
  // };

  const isRenewedPolicy = (item, allPolicies) => {
    return allPolicies?.some(p => {
      if (p.vehicle_no !== item.vehicle_no || p.id === item.id) return false;

      const startDate = new Date(p.policy_start_date);
      const expiryDate = new Date(item.policy_expiry_date);
      const days = (startDate - expiryDate) / (1000 * 60 * 60 * 24);

      return days >= -45 && days <= 45;
    });
  };


  const renderRenewButton = (item, allPolicies) => {
    const days = moment(item?.policy_expiry_date).diff(
      moment(new Date()).format("YYYY-MM-DD"),
      "days"
    );

    const renewed = isRenewedPolicy(item, allPolicies);

    return (
      <>
        {renewed ? (
          <button className="btn btn-sm btn-primary mt-2 fs-7" disabled>
            Renewed
          </button>
        ) : 8 <= days && days <= 45 && !item?.quote ? (
          <button
            className={`btn btn-sm btn-primary mt-2 fs-7`}
            onClick={() => {
              setPolicyId(props.detail.id);
              if (props.detail.id) {
                dispatch(actionSourceForEnquiry({ policy_id: props.detail.id }));
              }
            }}
          >
            Renew Policy
          </button>
        ) : item?.quote &&
          (["success", "under process"].includes(item?.quote?.renewal_status?.toLowerCase())) ? (
          <button className="btn btn-sm btn-primary mt-2 fs-7" disabled>
            {item?.quote?.renewal_status}
          </button>
        ) : 0 <= days && days <= 45 && item?.quote ? (
          <button className="btn btn-sm btn-primary mt-2 fs-7" onClick={(e) => {
            e.preventDefault();
            setPolicyId(props.detail.id);
            if (props.detail.id) {
              dispatch(actionSourceForEnquiry({ policy_id: props.detail.id }));
            }
          }}>
            {item?.quote?.renewal_status}
          </button>
        ) : days <= 7 && !item?.quote ? (
          <button className="btn btn-sm btn-primary mt-2 fs-7" disabled>
            NA
          </button>
        ) : days <= 0 ? (
          <button className="btn btn-sm btn-primary mt-2 fs-7" disabled>
            Expired
          </button>
        ) : null}
      </>
    );
  };


  // const renderRenewButton = (item) => {
  //   const days = moment(item?.policy_expiry_date).diff(
  //     moment(new Date()).format("YYYY-MM-DD"),
  //     "days"
  //   );

  //   return (
  //     <>
  //       {
  //         8 <= days && days <= 60 && !item?.quote ?
  //           <button
  //             className={`btn btn-sm btn-primary mt-2 fs-7`}
  //             onClick={() => {
  //               setPolicyId(props.detail.id);
  //               if (props.detail.id) {
  //                 dispatch(actionSourceForEnquiry({ policy_id: props.detail.id }));
  //               }
  //             }}
  //           >
  //             Renew Policy
  //           </button>
  //           :
  //           (item?.quote && (item?.quote?.renewal_status?.toLowerCase() === "success" || item?.quote?.renewal_status?.toLowerCase() === "under process")) ? (
  //             <button className="btn btn-sm btn-primary mt-2 fs-7" disabled>
  //               {item?.quote?.renewal_status}
  //             </button>
  //           ) :
  //             (0 <= days && days <= 60 && item?.quote) ? (
  //               <button className="btn btn-sm btn-primary mt-2 fs-7" onClick={(e) => {
  //                 e.preventDefault()
  //                 setPolicyId(props.detail.id);
  //                 if (props.detail.id) {
  //                   dispatch(actionSourceForEnquiry({ policy_id: props.detail.id }));
  //                 }
  //               }}>
  //                 {item?.quote?.renewal_status}
  //               </button>
  //             ) :
  //               days <= 7 && (!item?.quote) ? (
  //                 <button className="btn btn-sm btn-primary mt-2 fs-7" disabled>
  //                   {/* {item?.quote?.renewal_status} */}
  //                   NA
  //                 </button>
  //               ) : days <= 0 ? (
  //                 <button className="btn btn-sm btn-primary mt-2 fs-7" disabled>
  //                   {/* {item?.quote?.renewal_status} */}
  //                   Expired
  //                 </button>
  //               ) :
  //                 null}
  //     </>
  //   );
  // };

  // const renderProgressBar = (item) => {
  //   var date1 = moment(new Date()).startOf("day");
  //   var date2 = moment(item?.policy_expiry_date).startOf("day");
  //   var totalDays = date2.diff(date1, "days");

  //   // Calculate the percentage relative to the total number of days
  //   var percentage = (totalDays / 365) * 100; // Assuming 365 as the maximum days for 100%

  //   let color;
  //   if (totalDays <= 365 && totalDays > 60) {
  //     color = "bg-success";
  //   } else if (totalDays <= 60 && totalDays > 30) {
  //     color = "bg-warning";
  //   } else if (totalDays <= 30) {
  //     color = "bg-danger";
  //   } else {
  //     color = "bg-success"; // Default color if none of the conditions are met
  //   }

  //   return (
  //     <>
  //       {totalDays >= 7 ? <><p class="fw-600 mb-0">{totalDays} Days left</p>
  //         <div class="progress">
  //           <div
  //             class={`progress-bar ${color}`}
  //             role="progressbar"
  //             style={{ width: `${percentage}%` }}
  //             aria-valuenow={percentage}
  //             aria-valuemin="0"
  //             aria-valuemax="100"
  //           ></div>
  //         </div></> : <div></div>}
  //     </>
  //   );
  // };


  const renderProgressBar = (item, allPolicies) => {
    const renewed = isRenewedPolicy(item, allPolicies);
    if (renewed) return null; // ⛔ Don't show if already renewed

    const date1 = moment(new Date()).startOf("day");
    const date2 = moment(item?.policy_expiry_date).startOf("day");
    const totalDays = date2.diff(date1, "days");

    const percentage = (totalDays / 365) * 100;

    let color;
    if (totalDays <= 365 && totalDays > 60) {
      color = "bg-success";
    } else if (totalDays <= 60 && totalDays > 30) {
      color = "bg-warning";
    } else if (totalDays <= 30) {
      color = "bg-danger";
    } else {
      color = "bg-success";
    }

    return totalDays >= 7 ? (
      <>
        <p className="fw-600 mb-0">{totalDays} Days left</p>
        <div className="progress">
          <div
            className={`progress-bar ${color}`}
            role="progressbar"
            style={{ width: `${percentage}%` }}
            aria-valuenow={percentage}
            aria-valuemin="0"
            aria-valuemax="100"
          ></div>
        </div>
      </>
    ) :  <div className="progress"> </div>;
  };


  return (
    <>
      <div className="card policy-card mb-5 border">
        <div
          className="card-header "
          onClick={() => {
            handleToggle(props?.detailIndex);
          }}
        >
          <div className="row ">
            <div className="col-md-6 mt-2 mt-md-0">
              <span className="ms-auto fw-600 card-title">
                {props?.detail?.policy_type}
              </span>
            </div>
            <div className="col-md-6 text-right mt-2 mt-md-0">
              <div className="d-flex justify-content-end">
                <label className="card-label">Policy No.: </label>
                <p className="card-value mb-0"> {props?.detail?.policy_received_status == 'No' ? <div className="text-danger ms-1">Under Process</div> : props?.detail?.policy_no}</p>
              </div>
            </div>
          </div>
        </div>
        <div className="card-body pointer">
          <div className="row">
            <div class="col-md-4">
              {/* <label class="card-label ">Insured Name:</label> */}
              <label class="card-label ">User Name:</label>
              <p className="card-value mb-0">{props?.detail?.insured_name}</p>
            </div>
            <div class="col-md-5 mt-2 mt-md-0">
              <label className="card-label my-auto">
                Insurer Name:
                <p className="card-value mb-0 my-auto">
                  {" "}
                  {props?.detail?.insurer_name
                    ? props?.detail?.insurer_name
                    : "-"}
                </p>
              </label>
            </div>
            <div className="col-md-3 mt-2 mt-md-0">
              <label class="card-label">Premium:</label>
              <p className="card-value mb-0">
                ₹ {numDifferentiation(props?.detail?.gross_premium)}
              </p>
            </div>
            <div className="col-md-4 mt-3">
              <label className="card-label">Policy Start Date:</label>
              <p className="card-value mb-0">
                {props?.detail?.policy_start_date &&
                  moment(props?.detail?.policy_start_date).format("DD/MM/YYYY")}
              </p>
            </div>
            <div className="col-md-5 mt-3">
              <label className="card-label">Policy Expiry Date:</label>
              <p className="card-value mb-0">
                {props?.detail?.policy_expiry_date &&
                  moment(props?.detail?.policy_expiry_date).format(
                    "DD/MM/YYYY"
                  )}
              </p>
            </div>

            <div className="col-12 col-md-2 text-start mt-3">
              <label className="card-label text-primary fw-600" style={{display:'flex'}}>
                Status:
              </label>
              {renderProgressBar(props?.detail, props?.allPolicies)}
              {renderRenewButton(props?.detail, props?.allPolicies)}
              {/* <b>{props.detail?.quote?.renewal_status!= 'Pending' ? props.detail?.quote?.renewal_status :" "}</b> */}
            </div>
            <div className="col-md-4  mt-5 mt-md-0">
              <label className="card-label">Vehicle Number (Reg.No.)</label>
              {props?.detail?.vehicle_no == null || props?.detail?.vehicle_no == '' &&
                props?.detail?.biz_type === "New" ? (
                // moment(props?.detail?.policy_start_date).isAfter(
                //   moment(props?.detail?.activation_date))
                <div>
                  <button
                    className="btn btn-sm btn-primary mt-2 fs-7"
                    onClick={() => {
                      setIsUploadDoc(true);
                    }}
                  >
                    Upload RC Pending
                  </button>
                </div>
              ) : (
                <>
                  <p className="card-value mb-0">
                    {/* {props.detail.vehicle_no ? ( */}
                    <span>
                      {props?.detail?.vehicle_no}{" "}
                      {props?.detail?.biz_type === "New" &&
                        props?.vehicle_no === null &&
                        "(Verification Pending)"}
                    </span>
                    {/* ) : (
                      "-"
                    )} */}
                  </p>
                </>
              )}
            </div>
            <div className="col-12 col-md-2 text-start">
              <label className="card-label">TP Expiry Date:</label>
              <p className="card-value mb-0">
                {moment(props?.detail?.tp_expiry_date).format("DD/MM/YYYY")}
              </p>
            </div>
            <div className="row">
              <div className="col-md-4 mt-3">
                <label className="card-label">Capitalization Date: </label>
                <p className="card-value mb-0">
                  {props?.detail?.capitalization_date != null
                    ? moment(props?.detail?.capitalization_date).format(
                      "DD/MM/YYYY"
                    )
                    : "-"}
                  {/* Pending from BE */}
                </p>
              </div>
              {props?.detail?.paid_through == "CD Paid" ? (
                <>
                  <div className="col-md-4 mt-3">
                    <label className="card-label">CD Recovery Amount </label>
                    <p className="card-value mb-0">
                      {/* {props.detail.recovery_amount != null
                      ? Number(`₹ ${props?.detail?.recovery_amount}`)
                      : "-"} */}{
                        props?.detail?.cd_recovery_amount ? `₹ ${props?.detail?.cd_recovery_amount}` : '-'
                      }
                    </p>
                  </div>
                  <div className="col-md-4 mt-3">
                    <label className="card-label">CD Recovery Date:</label>
                    <p className="card-value mb-0">
                      {props?.detail?.cd_recovery_date != null
                        ? moment(
                          props?.detail?.cd_recovery_date
                        ).format("DD/MM/YYYY")
                        : "-"}
                    </p>
                  </div>
                </>
              ) : (
                <></>
              )}
            </div>
            <div
              className="col-12"
              ref={contentEl}
              hidden={clicked === props?.detailIndex ? false : true}
            >
              <div className="row mt-3 bg-light py-3 rounded fs-7 ">
                <div className="col-md-6">
                  <h6 class="mb-0">Current Plan (Add-On)</h6>
                  <div>
                    <p className="text-primary">
                      {props?.detail?.current_plan}
                    </p>
                    <p>
                      <b>Features :</b>
                      <ul>
                        {appliedFeatures && appliedFeatures.length ? (
                          appliedFeatures.map((item, index) => {
                            return (
                              <li
                                key={index}
                                data-toggle="tooltip"
                                data-placement="top"
                                title={
                                  !!featuresDescriptionMap
                                    ? featuresDescriptionMap[
                                    item.trim().toLowerCase()
                                    ]
                                    : item
                                }
                              >
                                {item}{" "}
                                <i className="fa fa-info-circle ms-2 cursor-pointer"></i>
                              </li>
                            );
                          })
                        ) : (
                          <></>
                        )}
                      </ul>
                    </p>
                  </div>
                </div>
                <div className="col-md-6">
                  <ul className="list-group">
                    <li className="list-group-item d-flex justify-content-between">
                      <span className="text-dark my-auto">
                        Status:{" "}
                        <b className="text-primary">
                          {_.capitalize(props?.detail?.policy_status)}
                        </b>
                      </span>
                      <button
                        className="btn btn-sm btn-primary fs-7"
                        onClick={() => {
                          navigation("/claim/intimate-claim", {
                            state: { data: props?.detail },
                          });
                        }}
                      >
                        Intimate Claim
                      </button>
                    </li>
                    <li className="list-group-item d-flex justify-content-between bg-light">
                      <span className="fw-bold">IDV</span>{" "}
                      <span className="fw-bold">
                        <i className="fa fa-inr" />{" "}
                        {numDifferentiation(props?.detail?.sum_insured)}
                      </span>
                    </li>
                    <li className="list-group-item d-flex justify-content-between">
                      <span>Net Premium</span>{" "}
                      <span>
                        <i className="fa fa-inr" />
                        {numDifferentiation(props?.detail?.net_premium)}
                      </span>
                    </li>
                    <li className="list-group-item d-flex justify-content-between">
                      <span>GST</span>{" "}
                      <span>
                        <i className="fa fa-inr" />{" "}
                        {numDifferentiation(props?.detail?.gst_amount)}
                      </span>
                    </li>
                    <li className="list-group-item d-flex justify-content-between">
                      <span>
                        <b>Gross Premium</b>
                      </span>
                      <b>
                        {" "}
                        <span>
                          <i className="fa fa-inr" />{" "}
                          {numDifferentiation(props?.detail?.gross_premium)}
                        </span>
                      </b>
                    </li>
                  </ul>
                </div>
                <div className="col-12 mt-3">
                  <h6>Documents({props?.detail?.documents?.length})</h6>
                </div>
                {renderDocuments(props?.detail?.documents)}

                {props?.detail?.endorsements?.length ? (
                  <>
                    <div
                      class="col-12 mt-3 cursor-pointer"
                      onClick={() => {
                        JSON.stringify(props?.detail?.endorsements);
                      }}
                    >
                      <h6>Endorsement</h6>
                    </div>
                    {renderEndorsement(props?.detail?.endorsements)}
                  </>
                ) : (
                  <></>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <RcUpload_Document
        show={isUploadDoc}
        policyObj={props.detail}
        handleClose={() => {
          setIsUploadDoc(false);
          // navigation("/policies");
          // window.location.reload();
        }}
      />
    </>
  );
};

export default PolicyCard;
